import store from '../store'

export default {

    /**
     * Get positions list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getPositionsList: state => (tasks) => {

        // Tasks can be a single task or tasks list
        if (!Array.isArray(tasks)) tasks = [tasks];

        // Return tasks list
        return Object.values(state.positions).filter(pos => tasks.includes(pos.task_id));
    },

    /**
     * Get users list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getPositionsUsersList: state => (tasks) => {

        // Tasks can be a single task or tasks list
        if (!Array.isArray(tasks)) tasks = [tasks];

        // Users list
        let usersList = {};

        // Construct users list
        Object.values(state.positions).filter(pos => tasks.includes(pos.task_id)).map(pos => {
           pos.users.map(u => {
               usersList[u.id] = u;
           });
        });

        // Return tasks list
        return usersList;
    },

    /**
     * Get position by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getPositionByID: state => (id) => {
        // Return user list
        return state.positions[id];
    },

    /**
     * Get HRs
     * @param state
     * @returns {default.campaigns|{}}
     */
    getHRPositionsList: state => {

        // Get current user id
        let user = store.getters['auth/currentUser'];

        // Tasks list to select
        let tasks = [];

        // Get HR team tasks
        Object.values(state.positions).map((pos) =>
        {
            // Check positions
            Object.values(pos.users).map((usr) =>
            {
                // Add task to the list
                if(usr.id == user.id)
                {
                    // Add task to the list
                    tasks.push(pos.task_id);
                }
            })
        });

        // Return tasks list
        return Object.values(state.positions).filter(pos => tasks.includes(pos.task_id));
    },

}
